import { type ReactNode } from 'react';
import { ButtonBase } from '@belong/ui';

type Props = {
  className?: string;
  children: ReactNode;
  variant: 'invitation' | 'post-inspection';
  onClick: () => void;
};

export function BelongStandardsWrapper({
  children,
  variant = 'invitation',
  onClick,
  className,
}: Props) {
  if (variant === 'invitation') {
    return <div className={className}>{children}</div>;
  }

  return (
    <ButtonBase onClick={onClick} className={className}>
      {children}
    </ButtonBase>
  );
}
